import { useState, useEffect } from 'react';

export const useDelayedLoading = (isLoading: boolean, delay: number = 200) => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isLoading) {
      // Only show loading after the delay
      timeoutId = setTimeout(() => {
        setShowLoading(true);
      }, delay);
    } else {
      // Hide loading immediately when done
      setShowLoading(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoading, delay]);

  return showLoading;
};